import { UUID } from 'uuidjs'
export function getUUID() {
  return (UUID.genV4() + '').replace(/-/g, '')
}

export function userCopyActionListener(DOM_selector) {
  const container = document.querySelector(DOM_selector)
  if (!container) return

  container.addEventListener('copy', function (e) {
    const clipboardData = e.clipboardData || window.clipboardData

    if (!clipboardData) return
    const text = window.getSelection().toString()
    if (text) {
      e.preventDefault()
      clipboardData.setData('text/html', container.innerHTML)
      clipboardData.setData('text/plain', text.replace(/\n+/g, '\n'))
    }
  })
}
